import { Tooltip, Typography } from "@suraasa/placebo-ui"
import { OrderItemType } from "api/resources/orders/types"
import clsx from "clsx"
import { InfoCircle } from "iconoir-react"
import { Link, useParams } from "react-router-dom"

import { renderAnalyticsMetric } from "./utils"

interface OverallGPAProps {
  gpa: number | undefined | null
  isCourse: boolean
  filteredCourseSlug: string | undefined
}

const OverallGPA = ({ gpa, isCourse, filteredCourseSlug }: OverallGPAProps) => {
  const { slug, parentSlug } = useParams() as {
    slug: string
    parentSlug?: string
  }

  const baseSlug = parentSlug || slug

  const highlightId = parentSlug
    ? slug
    : isCourse
    ? filteredCourseSlug
    : undefined

  // Gradebook is a qualification-level concept. A standalone course (no
  // parentSlug) has no qualification to build this link from — the old
  // code hardcoded the "qualification" prefix here regardless, producing a
  // broken link built from a course slug.
  const hasGradebookTarget = !isCourse || Boolean(parentSlug)

  const gradebookPath = `/${OrderItemType.QUALIFICATION}/${baseSlug}/gradebook${
    highlightId ? `?highlight-element-id=${highlightId}` : ""
  }`

  const toolTipContent = isCourse
    ? "Your course GPA is evaluated based on completed activities, assignments and assessments."
    : "Your overall GPA is evaluated based on completed activities, assignments and assessments. It will update as you progress through more courses."

  return (
    <div className="flex size-full flex-col justify-between p-2.5">
      <div className="mb-4 flex justify-between">
        <Typography
          variant="strongSmallBody"
          className="flex gap-1.5 text-muted"
        >
          {isCourse ? "Course" : "Overall"} GPA
          <span>
            <Tooltip content={toolTipContent}>
              <InfoCircle strokeWidth={2} fontSize={12} />
            </Tooltip>
          </span>
        </Typography>
        {hasGradebookTarget && (
          <Link to={gradebookPath}>
            <Typography
              variant="strongSmallBody"
              className="text-primary-500 hover:underline"
            >
              View Gradebook
            </Typography>
          </Link>
        )}
      </div>
      <div className="flex items-end gap-1.5">
        {renderAnalyticsMetric(gpa, ({ isNum, formattedValue }) => (
          <Typography
            variant="title1"
            className={clsx("text-onSurface-900", {
              "!font-thin text-onSurface-400": !isNum,
            })}
          >
            {formattedValue}
          </Typography>
        ))}
        {/* <Typography className="flex items-center gap-0.5 text-preTitle font-medium !tracking-normal text-[#20983B]">
          <span className="flex w-fit items-center rounded-[5px] bg-[#20983B] p-0.5 text-white">
            <ArrowUp fontSize={6} strokeWidth={4} className="mb-px" /> 25%
          </span>{" "}
          from last course
        </Typography> */}
      </div>
      {/* <Typography className="flex text-preTitle font-normal !tracking-normal text-muted">
        Predicted GPA :{" "}
        <span className="font-bold text-onSurface-700">9.2</span>
      </Typography> */}
    </div>
  )
}

export default OverallGPA
